import { render, staticRenderFns } from "./VerifyOTP.vue?vue&type=template&id=048ed517&"
import script from "./VerifyOTP.vue?vue&type=script&lang=js&"
export * from "./VerifyOTP.vue?vue&type=script&lang=js&"
import style0 from "./VerifyOTP.vue?vue&type=style&index=0&id=048ed517&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports